import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import IconArrowPrev from '../../Icons/IconArrowPrev';
import IconArrowFirst from '../../Icons/IconArrowFirst';
import IconArrowLast from '../../Icons/IconArrowLast';
import { useAuthStore } from '../../store/AuthContext';
import { useAppStore } from '../../store/AppContext';
import NoData from '../../components/NoData';

type Props = {
  data: TravelData[];
  total: number;
};

interface TravelData {
  fecha: string;
  concepto: string;
  importe: number;
  puntos: number;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CustomPaginationTable: FC<Props> = ({ data, total }) => {
  const { t } = useTranslation();
  const dataApp = useAppStore();

  const handleSizePerPageChange = (sizePerPage: number) => {
    console.log('handleSizePerPageChange', sizePerPage);
  };

  const dataUser = useAuthStore();
  const { moneda } = dataUser.user;

  const priceFormatter = (cell: any) => {
    let precioFormateado = cell as string;
    if (precioFormateado && precioFormateado.toString().indexOf('.') !== -1) {
      precioFormateado = precioFormateado.toString().replace(/\./g, ',');
      precioFormateado = `${precioFormateado}${
        moneda === 'euro' ? t('euro') : t('cc')
      }`;
    } else {
      precioFormateado = '';
    }
    return precioFormateado;
  };

  const dateFormatter = (cell: any) => {
    if (dataApp.lang === 'eu') {
      return moment(cell, 'DD/MM/YYYY').format('YYYY/MM/DD');
    }
    return cell;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const options = {
    page: 1,
    sizePerPage: 5,
    pageStartIndex: 1,
    paginationSize: 5, // the pagination bar size.

    prePage: (
      <div className="icon icon-medium">
        <IconArrowPrev />
      </div>
    ),
    nextPage: (
      <div className="icon icon-medium">
        <IconArrowPrev classCss="u-rotate-180" />
      </div>
    ),
    firstPage: (
      <div className="icon icon-medium go-back">
        <IconArrowFirst />
      </div>
    ),
    lastPage: (
      <div className="icon icon-medium">
        <IconArrowLast />
      </div>
    ),
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    onSizePerPageList: handleSizePerPageChange,
  };

  return (
    <>
      {(() => {
        if (data && data.length > 0) {
          return (
            <div className="table-responsive">
              <table className="table table--striped">
                <thead>
                  <tr>
                    <th>{t('travel.date')}</th>
                    <th>{t('travel.concept')}</th>
                    <th className="num">{t('travel.amount')}</th>
                    <th className="num">{t('travel.points')}</th>
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data.map((travelData) => (
                      <tr>
                        <td>
                          <span>{dateFormatter(travelData.fecha)}</span>
                        </td>
                        <td>
                          <span>{travelData.concepto}</span>
                        </td>
                        <td className="num">
                          <span>{priceFormatter(travelData.importe)}</span>
                        </td>
                        <td className="num num-color">
                          <span>{travelData.puntos}</span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          );
        }
        return (
          <NoData>
            <div className="mensaje">
              <p>{t('travel.noRecords')}</p>
            </div>
          </NoData>
        );
      })()}
    </>
  );
};

export default CustomPaginationTable;
